export type CoralogixCustomLogSeverity = 'debug' | 'verbose' | 'info' | 'warn' | 'error' | 'critical';

type CoralogixRumApi = Record<CoralogixCustomLogSeverity, (message: string, extraData?: Record<string, unknown>) => void>;

function getCoralogixRum(): CoralogixRumApi | undefined {
  if (typeof globalThis === 'undefined') {
    return undefined;
  }
  return (globalThis as unknown as { CoralogixRum?: CoralogixRumApi }).CoralogixRum;
}

export function sendCoralogixCustomEvent(
  message: string,
  data?: Record<string, unknown> | null,
  severity: CoralogixCustomLogSeverity = 'error'
): void {
  const rum = getCoralogixRum();
  const log = rum?.[severity];
  if (typeof log === 'function') {
    log.call(rum, message, data ?? undefined);
  }
}
